export const LOCALES = {
  'pt-BR': {
    code: 'pt-BR',
    short: 'PT',
    flag: 'br',
    label: 'Português',
    nativeLabel: 'Português (Brasil)',
    htmlLang: 'pt-BR',
    dateLocale: 'pt-BR',
  },
  en: {
    code: 'en',
    short: 'EN',
    flag: 'us',
    label: 'English',
    nativeLabel: 'English',
    htmlLang: 'en',
    dateLocale: 'en-US',
  },
};

export const DEFAULT_LOCALE = 'pt-BR';
export const LOCALE_STORAGE_KEY = 'nexus_locale';

export const LOCALE_LIST = Object.values(LOCALES);

export function isSupportedLocale(code) {
  return Boolean(LOCALES[code]);
}

export function resolveLocale(code) {
  if (isSupportedLocale(code)) return code;
  if (typeof code === 'string') {
    const base = code.split('-')[0].toLowerCase();
    if (base === 'pt') return 'pt-BR';
    if (base === 'en') return 'en';
  }
  return DEFAULT_LOCALE;
}
